import React from "react";

// assets
import linkArrowImg from "../../assets/images/arrow-forward.png";

const PRCard = ({ releaseDate, title, link }) => {
  return (
    <div className="flex justify-between items-center p-6 bg-white" onClick={() => window.open(link, "_blank")}>
      <div>
        <p className="font-medium uppercase">{title}</p>
        <time className="font-light">{releaseDate}</time>
      </div>
      <img src={linkArrowImg} alt={title} className="w-9" />
      {/* <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-hmcHoverBlue w-9"
      >
        <img src={linkArrowImg} alt={title} />
      </a> */}
    </div>
  );
};

export default PRCard;
